var map = {
	"./af.json": 6003,
	"./am.json": 7063,
	"./ar.json": 9555,
	"./az.json": 3847,
	"./be.json": 2286,
	"./bg.json": 9849,
	"./bn.json": 8999,
	"./br.json": 9993,
	"./bs.json": 7137,
	"./ca.json": 47,
	"./cs.json": 2825,
	"./cy.json": 5598,
	"./da.json": 1347,
	"./de.json": 1006,
	"./dv.json": 2577,
	"./el.json": 5467,
	"./en.json": 7803,
	"./es.json": 2394,
	"./et.json": 4026,
	"./eu.json": 9829,
	"./fa.json": 8886,
	"./fi.json": 5822,
	"./fr.json": 2260,
	"./ga.json": 7081,
	"./gl.json": 9063,
	"./ha.json": 2289,
	"./he.json": 6809,
	"./hi.json": 9680,
	"./hr.json": 3098,
	"./hu.json": 5509,
	"./hy.json": 5568,
	"./id.json": 8152,
	"./is.json": 8002,
	"./it.json": 1093,
	"./ja.json": 6876,
	"./ka.json": 1633,
	"./kk.json": 7640,
	"./km.json": 206,
	"./ko.json": 1171,
	"./ku.json": 2112,
	"./ky.json": 370,
	"./lt.json": 4508,
	"./lv.json": 3963,
	"./mk.json": 5491,
	"./ml.json": 2032,
	"./mn.json": 6768,
	"./mr.json": 7095,
	"./ms.json": 9646,
	"./nb.json": 3637,
	"./nl.json": 9486,
	"./nn.json": 5644,
	"./no.json": 6226,
	"./pl.json": 5958,
	"./ps.json": 9413,
	"./pt.json": 1818,
	"./ro.json": 8501,
	"./ru.json": 6625,
	"./sd.json": 6169,
	"./sk.json": 3331,
	"./sl.json": 2263,
	"./so.json": 3716,
	"./sq.json": 1684,
	"./sr.json": 5527,
	"./sv.json": 4934,
	"./sw.json": 8498,
	"./ta.json": 4271,
	"./tg.json": 4438,
	"./th.json": 4975,
	"./tr.json": 6168,
	"./tt.json": 3899,
	"./ug.json": 697,
	"./uk.json": 2297,
	"./ur.json": 5208,
	"./uz.json": 4868,
	"./vi.json": 2246,
	"./zh.json": 4390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3197;